export default "__VITE_ASSET__BWWQcJzR__"